import { PatternWarningLevels } from '../constants/pattern-warning-levels'

/**
 * Ant Design Alert types
 */
export const ALERT_TYPES = {
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
    SUCCESS: 'success',
}

/**
 * Maps pattern warning level (numeric ID from backend) to Ant Design Alert type
 * @param {number} warningLevel - Pattern warning level ID (0-3)
 * @returns {string} Alert type ('error', 'warning', 'info', 'success')
 */
export const getAlertType = warningLevel => {
    switch (warningLevel) {
        case PatternWarningLevels.HIGH:
            return ALERT_TYPES.ERROR
        case PatternWarningLevels.MODERATE:
            return ALERT_TYPES.WARNING
        case PatternWarningLevels.NEUTRAL:
            return ALERT_TYPES.INFO
        case PatternWarningLevels.POSITIVE:
            return ALERT_TYPES.SUCCESS
        default:
            return ALERT_TYPES.INFO
    }
}

